import _, { filter } from "lodash";
import { useEffect, useState } from "react";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

export default function useTierBasedTags() {
  const featureFlags = useFeatureFlag();
  const [data, setData] = useState({ tierBasedTags: [], allTierBasedTags: [] });
  useEffect(() => {
    const { cancel, promise } = featureFlags.RISK_TIERS ? GlobalSettingAPI.getTierBasedTagsV2() : GlobalSettingAPI.getTierBasedTags();
    const { cancel: cancel2, promise: promise2 } =
      GlobalSettingAPI.getAssetScoreTags();
    Promise.all([promise, promise2]).then(([response, response2]) => {
      setData({
        tierBasedTags: response || [],
        allTierBasedTags: filter(response2, (ds) => !ds.field),
      });
    });
    return () => {
      cancel2();
      cancel();
    };
  }, []);
  return { ...data };
}
